// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.css */

.render-lead .react-form-builder-form {
    display: block;
  }
  
  .render-lead .rfb-item {
    margin-bottom: 1rem;
  }
  
  .render-lead .form-group {
    margin-bottom: 1rem;
  }
  
  .render-lead .form-label {
    display: flex;
  }
  
  .render-lead .form-control {
    width: 100%;
    padding: 0.5rem;
    border: 1px solid var(--color-border-light2);
    border-radius: 4px;
  }
  
  .render-lead .btn-toolbar {
    margin-top: 1rem;
  }

  .render-lead .custom-control-label{
    margin-left: 1rem;
  }

  .render-lead .validation-error{
    background: rgba(244, 82, 82, 0.2);
    padding: 1rem;
    display: flex;
    justify-content: space-between;
    border-radius: 10px;
    margin-bottom: 10px;
  }

  .render-lead .label-required{
    color: var(--color-error-alt);
     font-size: 26px;
     margin-bottom: 0px;
     position: relative;
     bottom: 6px;
  }

  .render-lead .SortableItem .row{
    display: flex;
    column-gap: 10px;
  }

  
  /* Add any other styles as needed */
  `, "",{"version":3,"sources":["webpack://./src/content/leadGeneration/RenderLeadForm.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;IACI,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;IACf,4CAA4C;IAC5C,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kCAAkC;IAClC,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;KAC5B,eAAe;KACf,kBAAkB;KAClB,kBAAkB;KAClB,WAAW;EACd;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;;EAGA,mCAAmC","sourcesContent":["/* styles.css */\r\n\r\n.render-lead .react-form-builder-form {\r\n    display: block;\r\n  }\r\n  \r\n  .render-lead .rfb-item {\r\n    margin-bottom: 1rem;\r\n  }\r\n  \r\n  .render-lead .form-group {\r\n    margin-bottom: 1rem;\r\n  }\r\n  \r\n  .render-lead .form-label {\r\n    display: flex;\r\n  }\r\n  \r\n  .render-lead .form-control {\r\n    width: 100%;\r\n    padding: 0.5rem;\r\n    border: 1px solid var(--color-border-light2);\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .render-lead .btn-toolbar {\r\n    margin-top: 1rem;\r\n  }\r\n\r\n  .render-lead .custom-control-label{\r\n    margin-left: 1rem;\r\n  }\r\n\r\n  .render-lead .validation-error{\r\n    background: rgba(244, 82, 82, 0.2);\r\n    padding: 1rem;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    border-radius: 10px;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .render-lead .label-required{\r\n    color: var(--color-error-alt);\r\n     font-size: 26px;\r\n     margin-bottom: 0px;\r\n     position: relative;\r\n     bottom: 6px;\r\n  }\r\n\r\n  .render-lead .SortableItem .row{\r\n    display: flex;\r\n    column-gap: 10px;\r\n  }\r\n\r\n  \r\n  /* Add any other styles as needed */\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
